import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Lang$SolvuuApi0 from "./lang.bs.js";
import * as Root$SolvuuApi0 from "./root.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Bolt0_option$Bolt0 from "bolt0/./bolt0_option.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
var equal = Lang$SolvuuApi0.Label.equal;
var Label_header =
/* `Named */
[699531161, "k"];
var Label_format =
/* `Named */
[699531161, "v"];
var Label_action =
/* `Positional */
[-300665356, 1];
var Label_columns =
/* `Named */
[699531161, "columns"];
var Label_has_header =
/* `Named */
[699531161, "has_header"];
var Label_separator =
/* `Named */
[699531161, "separator"];
var Label_comment_char =
/* `Named */
[699531161, "comment_char"];
var Label_shift_header =
/* `Named */
[699531161, "shift_header"];
var Label_quote =
/* `Named */
[699531161, "quote"];
var Label_data =
/* `Positional */
[-300665356, 1];
var Label = {
  equal: equal,
  header: Label_header,
  format: Label_format,
  action: Label_action,
  columns: Label_columns,
  has_header: Label_has_header,
  separator: Label_separator,
  comment_char: Label_comment_char,
  shift_header: Label_shift_header,
  quote: Label_quote,
  data: Label_data
};
var parser =
/* `Var */
[4298439, Root$SolvuuApi0.identity];
var Default = {
  parser: parser
};
var Const = {
  Label: Label,
  Default: Default
};

function Make(Record_param, Const) {
  var $$Error = {};

  var to_record = function to_record(param) {
    var quote = param.quote;
    var comment_char = param.comment_char;
    var columns = Bolt0_list$Bolt0.map(function (param) {
      var action = param.action >= 925778591 ?
      /* `String */
      [-976970511, "skip"] :
      /* `String */
      [-976970511, "keep"];

      var map = Curry._1(Record_param.R.of_alist,
      /* :: */
      [
      /* tuple */
      [Const.Label.header, param.header],
      /* :: */
      [
      /* tuple */
      [Const.Label.format, param.format],
      /* :: */
      [
      /* tuple */
      [Const.Label.action, action],
      /* [] */
      0]]]);

      if (map[0] >= 17724) {
        return (
          /* `Record */
          [847309489, map[1]]
        );
      } else {
        throw [Caml_builtin_exceptions.assert_failure,
        /* tuple */
        ["csv.ml", 101, 14]];
      }
    }, param.columns);

    var match = Curry._1(Record_param.R.of_alist, Pervasives.$at(
    /* :: */
    [
    /* tuple */
    [Const.Label.columns,
    /* `List */
    [848054398, columns]],
    /* :: */
    [
    /* tuple */
    [Const.Label.has_header,
    /* `Bool */
    [737456202, param.has_header]],
    /* :: */
    [
    /* tuple */
    [Const.Label.separator,
    /* `Char */
    [748194550, param.separator]],
    /* :: */
    [
    /* tuple */
    [Const.Label.shift_header,
    /* `Bool */
    [737456202, param.shift_header]],
    /* :: */
    [
    /* tuple */
    [Const.Label.data, param.data],
    /* [] */
    0]]]]], Pervasives.$at(typeof quote === "number" ?
    /* [] */
    0 :
    /* :: */
    [
    /* tuple */
    [Const.Label.quote,
    /* `Char */
    [748194550, quote[1]]],
    /* [] */
    0], comment_char !== undefined ?
    /* :: */
    [
    /* tuple */
    [Const.Label.comment_char,
    /* `Char */
    [748194550, comment_char]],
    /* [] */
    0] :
    /* [] */
    0)));

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["csv.ml", 127, 8]];
    }
  };

  var column = function column(param) {
    if (typeof param === "number") {
      if (param !== 870828711) {
        return (
          /* `Error */
          [106380200,
          /* Invalid */
          144245463]
        );
      } else {
        return (
          /* `Ok */
          [17724, {
            header: Const.Default.parser,
            format: Const.Default.parser,
            action:
            /* Skip */
            925778591
          }]
        );
      }
    } else if (param[0] !== 847309489) {
      return (
        /* `Error */
        [106380200,
        /* Invalid */
        144245463]
      );
    } else {
      var r = param[1];
      var match = Bolt0_option$Bolt0.bind(Curry._2(Record_param.R.find, r, Const.Label.action), function (param) {
        if (typeof param === "number" || param[0] !== -976970511) {
          return;
        } else {
          switch (param[1]) {
            case "keep":
              return (
                /* Keep */
                836762789
              );

            case "skip":
              return (
                /* Skip */
                925778591
              );

            default:
              return;
          }
        }
      });
      var action = match !== undefined ? match :
      /* Keep */
      836762789;

      var find = function find(x) {
        return Bolt0_option$Bolt0.value(Curry._2(Record_param.R.find, r, x), Const.Default.parser);
      };

      var header = find(Const.Label.header);
      var format = find(Const.Label.format);
      return (
        /* `Ok */
        [17724, {
          header: header,
          format: format,
          action: action
        }]
      );
    }
  };

  var columns = Curry._1(Record_param.Arg_type.create, function (param) {
    if (typeof param === "number" || param[0] !== 848054398) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var match = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(column, param[1]));

      if (match[0] >= 106380200) {
        return match[1];
      } else {
        return (
          /* `Ok */
          [17724, match[1]]
        );
      }
    }
  });

  var string_or_blob = Curry._1(Record_param.Arg_type.create, function (x) {
    if (typeof x === "number") {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var variant = x[0];

      if (variant !== -976970511 && variant !== 295523485) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, x]
        );
      }
    }
  });

  var Arg_type = {
    columns: columns,
    string_or_blob: string_or_blob
  };
  var func = Record_param.Flag.map;

  var arg = function arg(param) {
    if (param !== undefined) {
      return (
        /* `Ok */
        [17724,
        /* `Using */
        [1029891364, param]]
      );
    } else {
      return (
        /* `Ok */
        [17724,
        /* No_quoting */
        541538907]
      );
    }
  };

  var quote = function (param) {
    return Curry._2(func, param, arg);
  }(Curry._1(Record_param.Flag.optional, Record_param.Arg_type.$$char));

  var Flag = {
    quote: quote
  };

  var of_record = function of_record(record) {
    var L = Const.Label;

    var columns$1 = Curry._2(Record_param.flag, L.columns, Curry._1(Record_param.Flag.required, columns));

    var separator = Curry._2(Record_param.flag, L.separator, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$char));

    var quote$1 = Curry._2(Record_param.flag, L.quote, quote);

    var has_header = Curry._2(Record_param.flag, L.has_header, Curry._1(Record_param.Flag.required, Record_param.Arg_type.bool));

    var comment_char = Curry._2(Record_param.flag, L.comment_char, Curry._1(Record_param.Flag.optional, Record_param.Arg_type.$$char));

    var shift_header = Curry._2(Record_param.flag, L.shift_header, Curry._2(Record_param.Flag.optional_with_default, Record_param.Arg_type.bool, false));

    var data = Curry._2(Record_param.flag, L.data, Curry._1(Record_param.Flag.required, string_or_blob));

    var make = function make(columns, separator, comment_char, shift_header, quote, has_header, data) {
      return {
        columns: columns,
        separator: separator,
        comment_char: comment_char,
        shift_header: shift_header,
        quote: quote,
        has_header: has_header,
        data: data
      };
    };

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), columns$1), separator), comment_char), shift_header), quote$1), has_header), data);

    return Curry._2(Record_param.parse, record, param);
  };

  return {
    $$Error: $$Error,
    to_record: to_record,
    Arg_type: Arg_type,
    Flag: Flag,
    of_record: of_record
  };
}

var partial_arg = Lang$SolvuuApi0.Record.Param;

var include = function (param) {
  var $$Error = {};

  var to_record = function to_record(param$1) {
    var quote = param$1.quote;
    var comment_char = param$1.comment_char;
    var columns = Bolt0_list$Bolt0.map(function (param$2) {
      var action = param$2.action >= 925778591 ?
      /* `String */
      [-976970511, "skip"] :
      /* `String */
      [-976970511, "keep"];

      var map = Curry._1(partial_arg.R.of_alist,
      /* :: */
      [
      /* tuple */
      [param.Label.header, param$2.header],
      /* :: */
      [
      /* tuple */
      [param.Label.format, param$2.format],
      /* :: */
      [
      /* tuple */
      [param.Label.action, action],
      /* [] */
      0]]]);

      if (map[0] >= 17724) {
        return (
          /* `Record */
          [847309489, map[1]]
        );
      } else {
        throw [Caml_builtin_exceptions.assert_failure,
        /* tuple */
        ["csv.ml", 101, 14]];
      }
    }, param$1.columns);

    var match = Curry._1(partial_arg.R.of_alist, Pervasives.$at(
    /* :: */
    [
    /* tuple */
    [param.Label.columns,
    /* `List */
    [848054398, columns]],
    /* :: */
    [
    /* tuple */
    [param.Label.has_header,
    /* `Bool */
    [737456202, param$1.has_header]],
    /* :: */
    [
    /* tuple */
    [param.Label.separator,
    /* `Char */
    [748194550, param$1.separator]],
    /* :: */
    [
    /* tuple */
    [param.Label.shift_header,
    /* `Bool */
    [737456202, param$1.shift_header]],
    /* :: */
    [
    /* tuple */
    [param.Label.data, param$1.data],
    /* [] */
    0]]]]], Pervasives.$at(typeof quote === "number" ?
    /* [] */
    0 :
    /* :: */
    [
    /* tuple */
    [param.Label.quote,
    /* `Char */
    [748194550, quote[1]]],
    /* [] */
    0], comment_char !== undefined ?
    /* :: */
    [
    /* tuple */
    [param.Label.comment_char,
    /* `Char */
    [748194550, comment_char]],
    /* [] */
    0] :
    /* [] */
    0)));

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["csv.ml", 127, 8]];
    }
  };

  var column = function column(param$1) {
    if (typeof param$1 === "number") {
      if (param$1 !== 870828711) {
        return (
          /* `Error */
          [106380200,
          /* Invalid */
          144245463]
        );
      } else {
        return (
          /* `Ok */
          [17724, {
            header: param.Default.parser,
            format: param.Default.parser,
            action:
            /* Skip */
            925778591
          }]
        );
      }
    } else if (param$1[0] !== 847309489) {
      return (
        /* `Error */
        [106380200,
        /* Invalid */
        144245463]
      );
    } else {
      var r = param$1[1];
      var match = Bolt0_option$Bolt0.bind(Curry._2(partial_arg.R.find, r, param.Label.action), function (param) {
        if (typeof param === "number" || param[0] !== -976970511) {
          return;
        } else {
          switch (param[1]) {
            case "keep":
              return (
                /* Keep */
                836762789
              );

            case "skip":
              return (
                /* Skip */
                925778591
              );

            default:
              return;
          }
        }
      });
      var action = match !== undefined ? match :
      /* Keep */
      836762789;

      var find = function find(x) {
        return Bolt0_option$Bolt0.value(Curry._2(partial_arg.R.find, r, x), param.Default.parser);
      };

      var header = find(param.Label.header);
      var format = find(param.Label.format);
      return (
        /* `Ok */
        [17724, {
          header: header,
          format: format,
          action: action
        }]
      );
    }
  };

  var columns = Curry._1(partial_arg.Arg_type.create, function (param) {
    if (typeof param === "number" || param[0] !== 848054398) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var match = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(column, param[1]));

      if (match[0] >= 106380200) {
        return match[1];
      } else {
        return (
          /* `Ok */
          [17724, match[1]]
        );
      }
    }
  });

  var string_or_blob = Curry._1(partial_arg.Arg_type.create, function (x) {
    if (typeof x === "number") {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var variant = x[0];

      if (variant !== -976970511 && variant !== 295523485) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, x]
        );
      }
    }
  });

  var Arg_type = {
    columns: columns,
    string_or_blob: string_or_blob
  };
  var func = partial_arg.Flag.map;

  var arg = function arg(param) {
    if (param !== undefined) {
      return (
        /* `Ok */
        [17724,
        /* `Using */
        [1029891364, param]]
      );
    } else {
      return (
        /* `Ok */
        [17724,
        /* No_quoting */
        541538907]
      );
    }
  };

  var quote = function (param) {
    return Curry._2(func, param, arg);
  }(Curry._1(partial_arg.Flag.optional, partial_arg.Arg_type.$$char));

  var Flag = {
    quote: quote
  };

  var of_record = function of_record(record) {
    var L = param.Label;

    var columns$1 = Curry._2(partial_arg.flag, L.columns, Curry._1(partial_arg.Flag.required, columns));

    var separator = Curry._2(partial_arg.flag, L.separator, Curry._1(partial_arg.Flag.required, partial_arg.Arg_type.$$char));

    var quote$1 = Curry._2(partial_arg.flag, L.quote, quote);

    var has_header = Curry._2(partial_arg.flag, L.has_header, Curry._1(partial_arg.Flag.required, partial_arg.Arg_type.bool));

    var comment_char = Curry._2(partial_arg.flag, L.comment_char, Curry._1(partial_arg.Flag.optional, partial_arg.Arg_type.$$char));

    var shift_header = Curry._2(partial_arg.flag, L.shift_header, Curry._2(partial_arg.Flag.optional_with_default, partial_arg.Arg_type.bool, false));

    var data = Curry._2(partial_arg.flag, L.data, Curry._1(partial_arg.Flag.required, string_or_blob));

    var make = function make(columns, separator, comment_char, shift_header, quote, has_header, data) {
      return {
        columns: columns,
        separator: separator,
        comment_char: comment_char,
        shift_header: shift_header,
        quote: quote,
        has_header: has_header,
        data: data
      };
    };

    var param$1 = Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._2(partial_arg.Applicative_infix.$less$star$great, Curry._1(partial_arg.$$return, make), columns$1), separator), comment_char), shift_header), quote$1), has_header), data);

    return Curry._2(partial_arg.parse, record, param$1);
  };

  return {
    $$Error: $$Error,
    to_record: to_record,
    Arg_type: Arg_type,
    Flag: Flag,
    of_record: of_record
  };
}(Const);

function Arg_Make(funarg, funarg$1) {
  var $$let = Make(funarg, funarg$1);
  return {
    $$Error: $$let.$$Error,
    of_record: $$let.of_record,
    to_record: $$let.to_record
  };
}

var Arg_Error = include.$$Error;
var Arg_of_record = include.of_record;
var Arg_to_record = include.to_record;
var Arg = {
  Make: Arg_Make,
  $$Error: Arg_Error,
  of_record: Arg_of_record,
  to_record: Arg_to_record
};
export { Const, Arg };
/* include Not a pure module */